export default "__VITE_ASSET__wlVUWzQ9__"